/**
 * @file: 卧柜列选择
 * @author: xiaolong.huang@dmall.com
 */

import * as CaptureRule from '../captureRule';
import { selectByTarget } from './selectByTargetCube';

function cabinetColSelect(ev: JQuery.MouseDownEvent): void {
    let $target: JQuery<EventTarget> = $(ev.target);
    let targetCube: CubeId = CaptureRule.queryCubeIdBeHit($target);

    selectByTarget(targetCube);
}

export {
    cabinetColSelect
}
